import styled, { css } from 'styled-components';
export const IconDown = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;  
  margin-right:-20px;
  font-size: 1.5rem;
  transition: margin-right 0100ms;
`
export const Container = styled.div`
  position: relative;  
  display: flex;
  cursor: pointer;
  align-items: center;
  margin-top: 0.5rem;
  min-height: 4.5rem;   
  background-color: ${(props) => (props.active ? '#ebebeb' : '')};

  /* &:hover{
    background-color:${(props) => (props.active ? '#ebebeb' : '#f5f5f5')};
    ${IconDown}{
      margin-right:0px;
    }
  }   */

  ${(props) => (props.disabled &&
    css`
      pointer-events:none;
      opacity: 0.7;
    `
  )}
  
  ${(props) => (props.isSelected &&
    css`
      background: rgb(100 167 245 / 20%);
      //animation: pulse 350ms;
    `
  )}

${({ enabledSelection }) => (enabledSelection
    ? css`
      &:hover{
        //background: #0daa9726;
      }
    `
    : css`
      &:hover{
        background-color:${(props) => (props.active ? '#ebebeb' : '#f5f5f5')};
        ${IconDown}{
          margin-right:0px;
        }
      }
    `
  )}

`
export const Content = styled.div`
  width: 100%;
  height: 100%;
  padding:0.5rem;
  border-radius: 5px;
  border-bottom: 1px solid #eee;
  border-left: 4px solid #1D86FF;

`
export const Line = styled.div`
  width: 100%;
  height:50%;
  display:flex;
  flex-direction:row;
  justify-content:space-between;
  align-items:center;
  overflow: hidden;

  .icon-line{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.2rem;
  }
  .infoUser{
    display: flex;
    gap: 0.5rem;
    width: 100%;
  }
  .call--status{
    display: flex;
    width: 100%;
    margin-top: 5px;
  }

`
export const Name = styled.p`
  margin: 0px;
  display: inline;
  border: 0;
  outline: none;
  max-width: 185px;

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  span{
    font-size: 1.2rem;
    font-weight: 500;
    color: black;
  }
`
export const Date = styled.p`
  min-width: 7rem;
  display: flex;
  justify-content: end;
  font-size: 0.75rem;
`
export const Tag = styled.span`
  margin-right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding:5px;
  border-radius: 3px;
  height: 16px;
  font-size: 11px;
  line-height: 16px;
  color: #54656f;
  background-color: #d0d0d0;
  border: 1px solid #d0d0d0;
  margin-top: 0.3rem;

  ${(props) =>
    props.type === 'note' &&
    css`
      &{
        color: #000;
        background-color: #f6b610;
        border: 1px solid #f6b610;
      }
    `}
  ${(props) =>
    props.type === 'in call' &&
    css`
      &{
        color: #fff;
        background-color: #ff5252;
        border: 1px solid #ff5252;
      }
    `}
  ${(props) =>
    props.type === 'invite' &&
    css`
      &{
        color: #fff;
        background-color: #00a884;
        border: 1px solid #00a884;
      }
    `}  
  ${(props) =>
    props.type === 'inFo' &&
    css`
      &{
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0.3rem;
        max-width: 210px;
        color: black;
        background-color:#1D86FF3b;
        border:0px;
        border-radius:3px;
        border-left: 3px solid #1D86FF;
        font-size: 1rem;
        box-shadow: 0 2px 1px -1px rgb(0 0 0 / 20%), 0 1px 1px 0 rgb(0 0 0 / 14%), 0 1px 3px 0 rgb(0 0 0 / 12%);

        span{
          height: 100%;
          display: flex;
          font-size: 1rem;
          justify-content: center;
          align-items: center;
        }


        p{
          max-width: 100%;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

      }
    `}      
`
export const IconCaM = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;

  .cameraVideo{
    color:#fff;
    font-size: 0.9rem;
  }
  .blob-cam-inCall{
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    transform: scale(1);
    background: rgba(255, 82, 82, 1);
    box-shadow: 0 0 0 0 rgba(255, 82, 82, 1);
    animation: pulse-red 2s infinite;

    @keyframes pulse-red {
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 82, 82, 0.7);
      }
      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(255, 82, 82, 0);
      }
      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(255, 82, 82, 0);
      }
    }
  }
  .blob-cam-invite{
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      height: 20px;
      width: 20px;
      transform: scale(1);
      background: rgba(0,168,132, 1);
      box-shadow: 0 0 0 0  rgba(0,168,132, 1);
      animation: pulse-s 2s infinite;

      @keyframes pulse-s {
        0% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba(0,168,132, 0.7);
        }
        70% {
          transform: scale(1);
          box-shadow: 0 0 0 10px rgba(0,168,132, 0);
        }
        100% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba(0,168,132, 0);
        }
      }
    }
`

export const IsSelected = styled.div`
  display: flex;
  width: 50px;
  height: 50px;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: #ffffff;
  background-color:#1D86FF;
`;

export const Options = styled.div`
  position: absolute;
  right:8px;
  top:35px;
  z-index: 1;
  transform-origin: left top;
  transform: scale(1);
  overflow: hidden;
  border-radius: 0.42rem;
  background: #fff;
  box-shadow: 1px 2px 4px rgba(0, 0, 0, 0.2);
  li {
    list-style: none;
    cursor: pointer;
    padding: 0.925rem 1.5rem;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.82rem;
    color: black;
    transition: all 260ms ease-in-out;
    &:hover {
      color: black;
      background-color:#f5f6f6; ;
    }
  }
  ${(props) =>
    !props.menuOpen &&
    css`
      li {
        font-size: 0rem;
        padding: 0rem;
      }
      &::before,
      li + li {
        border-width: 0px;
      }
    `}
`

export const IconNotification = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;  
  font-size: 1.5rem;
  color: #03d755;
`
export const Loading = styled.div`
  position: relative;  
  width: 100%;
  height: 2px;
  background-color:rgba(0,168,132, 1); 

  &::before{
    position: absolute;
    content: "";
    width: 100%;
    height: 2px;
    background-image: linear-gradient(to right, #e9ecef 0%, rgba(0,0,0,0.05) 20%, #e9ecef 40%, #e9ecef 100%);
    background-repeat: no-repeat;
    background-size: 750px 400px;
    animation: shimmer 2s linear infinite;
  }
  
`;